<template>
  <div class="result active" :class="{active: storeIsOpen}">
    <div v-if="storeData">
      <div class="title main-setting-title">
        <a href="#" class="back-to-result" @click.prevent="closeStore" v-if="!storeInExt"></a>
        {{ storeData.name }} deals
      </div>
      <div class="store-content">
        <div class="store-logo" v-lazy-container="{ selector: 'img'}">
          <img :data-src="logoIsError ? imgPlaceholder() : storeData.computed_logo" alt="logo"
               :data-error="imgPlaceholder()"
               data-loading="https://c.tenor.com/I6kN-6X7nhAAAAAj/loading-buffering.gif">
        </div>
        <p class="text-center store-text">{{storeData.description}}</p>
        <div class="store-controls">
          <SocialShare :storeData="storeData" v-if="shareIsOpen" v-click-outside="hideSocialShare"/>
          <router-link class="store-control"
                       target="_blank"
                       :to="{name: 'Loader',
                            query: {
                               url: storeData.website,
                               title: storeData.name,
                               type: 'shop',
                               swagbucks_merchant_id: storeData.swagbucks_merchant_id,
                               swagbucks_network_code: storeData.swagbucks_network_code,
                               icon: logoIsError ? imgPlaceholder() : storeData.computed_logo,
                               lcid: $route.query.lcid
                             }}"
                       v-if="storeData.website"
                       @click="visitStore"
          >
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.3628 2.63698C11.8465 -0.879363 6.15456 -0.879925 2.63772 2.63698C-0.878652 6.15332 -0.879179 11.8452 2.63772 15.362C6.15399 18.8784 11.8459 18.8789 15.3628 15.362C18.8791 11.8457 18.8796 6.15384 15.3628 2.63698ZM14.9867 14.0794C14.5663 13.7035 14.1166 13.3708 13.6426 13.0841C13.9559 12.0018 14.1415 10.8109 14.1854 9.57292H16.8308C16.7112 11.2416 16.07 12.8069 14.9867 14.0794ZM1.16967 9.57292H3.81509C3.85897 10.8109 4.04458 12.0018 4.35789 13.0841C3.88387 13.3708 3.43417 13.7035 3.01376 14.0794C1.93043 12.8069 1.28932 11.2416 1.16967 9.57292ZM3.0138 3.91963C3.43421 4.29556 3.88391 4.62825 4.35792 4.91497C4.04462 5.99721 3.859 7.18814 3.81513 8.42611H1.16967C1.28932 6.75748 1.93043 5.19216 3.0138 3.91963ZM8.42685 5.03349C7.49169 4.9666 6.59 4.73627 5.75407 4.3563C6.24023 3.10439 7.13648 1.60286 8.42685 1.23075V5.03349ZM8.42685 6.18244V8.42614H4.9624C5.00209 7.37892 5.15047 6.37332 5.39724 5.45323C6.3472 5.8685 7.36885 6.1165 8.42685 6.18244ZM8.42685 9.57292V11.8166C7.36885 11.8826 6.3472 12.1306 5.39724 12.5458C5.15047 11.6257 5.00209 10.6201 4.9624 9.57292H8.42685ZM8.42685 12.9656V16.7683C7.13655 16.3962 6.2403 14.8948 5.75407 13.6428C6.59 13.2628 7.49169 13.0325 8.42685 12.9656ZM9.57363 12.9656C10.5088 13.0325 11.4105 13.2628 12.2464 13.6428C11.7602 14.8947 10.864 16.3962 9.57363 16.7683V12.9656ZM9.57363 11.8166V9.57292H13.0381C12.9984 10.6201 12.85 11.6257 12.6032 12.5458C11.6533 12.1306 10.6316 11.8826 9.57363 11.8166ZM9.57363 8.42614V6.18244C10.6316 6.1165 11.6533 5.8685 12.6032 5.45323C12.85 6.37332 12.9984 7.37892 13.0381 8.42614H9.57363ZM9.57363 5.03349V1.23079C10.864 1.60289 11.7603 3.10442 12.2464 4.35633C11.4105 4.73627 10.5088 4.9666 9.57363 5.03349ZM12.1492 1.80326C12.8832 2.12468 13.568 2.5605 14.1818 3.10126C13.8896 3.35888 13.5813 3.59248 13.2594 3.80139C12.9735 3.0935 12.6082 2.40556 12.1492 1.80326ZM4.74109 3.80139C4.41915 3.59248 4.11087 3.35888 3.81864 3.10126C4.4325 2.5605 5.11727 2.12468 5.85126 1.80326C5.39222 2.40563 5.027 3.09357 4.74109 3.80139ZM4.74113 14.1977C5.027 14.9055 5.39229 15.5935 5.8513 16.1958C5.11731 15.8744 4.43253 15.4386 3.81868 14.8978C4.11087 14.6402 4.41918 14.4066 4.74113 14.1977ZM13.2594 14.1977C13.5813 14.4066 13.8896 14.6402 14.1818 14.8978C13.568 15.4385 12.8832 15.8743 12.1492 16.1958C12.6082 15.5935 12.9735 14.9056 13.2594 14.1977ZM14.1854 8.42614C14.1415 7.18818 13.9559 5.99721 13.6426 4.915C14.1166 4.62829 14.5663 4.2956 14.9867 3.91966C16.0701 5.19216 16.7112 6.75748 16.8308 8.42614H14.1854Z" fill="#00C6A2"/>
            </svg>
            Visit to store
          </router-link>
          <div class="store-control" @click="shareDeals">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.075 12.8718L11.439 13.0785L11.7065 12.7565C12.2394 12.115 13.0405 11.7077 13.9346 11.7077C15.5306 11.7077 16.8301 13.0074 16.83 14.6041C16.83 16.2004 15.5306 17.4999 13.9345 17.4999C12.3381 17.4999 11.0386 16.2004 11.0386 14.6042C11.0386 14.2649 11.0976 13.9397 11.2052 13.6371L11.3457 13.2419L10.981 13.0349L6.92538 10.7322L6.5614 10.5255L6.29392 10.8474C5.76107 11.4888 4.96016 11.8959 4.06631 11.8959C2.46961 11.8959 1.16992 10.5964 1.16992 9.00016C1.16992 7.40387 2.46961 6.10432 4.06631 6.10432C4.96017 6.10432 5.76115 6.51146 6.29399 7.15285L6.56149 7.47485L6.9255 7.26812L10.981 4.96488L11.3457 4.75777L11.2052 4.36262C11.0976 4.06009 11.0386 3.73499 11.0386 3.39576C11.0386 1.79948 12.3382 0.5 13.9346 0.5C15.5307 0.5 16.8301 1.79942 16.8299 3.39579V3.39583C16.8299 4.99295 15.5304 6.2927 13.9344 6.2927C13.0403 6.2927 12.2391 5.8853 11.7063 5.24356L11.4388 4.9214L11.0746 5.1282L7.01939 7.43135L6.65477 7.63844L6.79518 8.03355C6.9027 8.33612 6.96175 8.66116 6.96175 9.00024C6.96175 9.3394 6.9027 9.66444 6.79518 9.96701L6.65475 10.3622L7.01945 10.5692L11.075 12.8718ZM16.6418 3.39576C16.6418 1.90245 15.4278 0.688297 13.9346 0.688297C12.4412 0.688297 11.2269 1.90237 11.2269 3.39576C11.2269 4.88954 12.4409 6.10432 13.9346 6.10432C15.428 6.10432 16.6418 4.88946 16.6418 3.39576ZM1.3583 9.00024C1.3583 10.4936 2.57285 11.7077 4.06639 11.7077C5.55958 11.7077 6.77353 10.4934 6.77353 9.00024C6.77353 7.50689 5.55967 6.2927 4.06639 6.2927C2.57285 6.2927 1.3583 7.50668 1.3583 9.00024ZM11.2269 14.6042C11.2269 16.0975 12.4411 17.3117 13.9346 17.3117C15.4278 17.3117 16.6418 16.0975 16.6418 14.6042C16.6418 13.1107 15.428 11.896 13.9346 11.896C12.441 11.896 11.2269 13.1106 11.2269 14.6042Z" stroke="#00C6A2"/>
            </svg>
            Share deals
          </div>
          <div class="store-control" @click="toggleSaved">
            <svg :class="{'favorite-active': isFavorite}" width="14" height="18" viewBox="0 0 14 18"
                 fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M7.3779 13.4147L7 13.1942L6.6221 13.4147L1 16.6942V1.6875C1 1.16972 1.41972 0.75 1.9375 0.75H12.0625C12.5803 0.75 13 1.16972 13 1.6875V16.6942L7.3779 13.4147Z"
                  stroke="#00C6A2" stroke-width="1.5"/>
            </svg>
            <span v-if="isFavorite">
                Remove from favorite
            </span>
            <span v-else>
              Add to favorite
            </span>
          </div>
        </div>
        <div class="provider-list">
          <div class="w-100" :class="{'order-1': swagbucksMoreThanRakuten}" v-if="providers.includes('Rakuten')">
            <div class="store-offer">
              <div class="store-offer-header">
                <img :src="staticRakutenLogo" alt="logo" class="store-offer-header-logo">
                <span class="promocode-cashback"
                      :title="storeData.providers[providers.indexOf('Rakuten')].cashback_max_description"
                      v-if="storeData.providers && storeData.providers[providers.indexOf('Rakuten')].StoreOffer && storeData.providers[providers.indexOf('Rakuten')].StoreOffer[0]">
                  <span v-if="storeData.providers[providers.indexOf('Rakuten')].cashback_max">Cashback</span>
                  {{storeData.providers[providers.indexOf('Rakuten')].cashback_max || storeData.providers[providers.indexOf('Rakuten')].cashback_max_description }}{{storeData.providers[providers.indexOf('Rakuten')].cashback_max_currency}}
                </span>
              </div>
              <div class="store-offer-text">{{storeData.providers[providers.indexOf('Rakuten')].description}}</div>
              <div class="store-offer-footer"
                  :class="{'-end': storeData.providers && storeData.providers[providers.indexOf('Rakuten')].StoreOffer && !storeData.providers[providers.indexOf('Rakuten')].offers_count}">
                <span class="store-offer-footer-coupons" v-if="storeData.providers && storeData.providers[providers.indexOf('Rakuten')].StoreOffer && storeData.providers[providers.indexOf('Rakuten')].offers_count">
                  {{storeData.providers[providers.indexOf('Rakuten')].offers_count}} deals
                </span>
                <router-link class="btn-main"
                             target="_blank"
                             :to="{name: 'Loader', query: {
                               url: storeData.link,
                               type: 'cashback',
                               rakuten_merchant_id: storeData.rakuten_merchant_id,
                               title: 'Rakuten',
                               icon: logoIsError ? imgPlaceholder() : storeData.computed_logo,
                               storeImage: storeData.providers[providers.indexOf('Rakuten')].image || staticRakutenLogo,
                               lcid: $route.query.lcid
                             }}"
                @click="getRakuten">
                  Get deal
                </router-link>
              </div>
            </div>
          </div>

          <div class="w-100" v-if="providers.includes('Swagbucks')">
            <div class="store-offer">
              <div class="store-offer-header">
                <img :src="staticSwagbucksLogo" alt="logo" class="store-offer-header-logo">
                <span class="promocode-cashback"
                      :title="storeData.providers[providers.indexOf('Swagbucks')].cashback_max_description"
                      v-if="storeData.providers && storeData.providers[providers.indexOf('Swagbucks')].StoreOffer && storeData.providers[providers.indexOf('Swagbucks')].StoreOffer[0]">
                  <span v-if="storeData.providers[providers.indexOf('Swagbucks')].cashback_max">Cashback</span> {{storeData.providers[providers.indexOf('Swagbucks')].cashback_max || storeData.providers[providers.indexOf('Swagbucks')].cashback_max_description}}{{storeData.providers[providers.indexOf('Swagbucks')].cashback_max_currency}}
                </span>
              </div>
              <div class="store-offer-text">{{storeData.providers[providers.indexOf('Swagbucks')].description}}</div>
              <div class="store-offer-footer"
                   :class="{'-end': storeData.providers && storeData.providers[providers.indexOf('Swagbucks')].StoreOffer && !storeData.providers[providers.indexOf('Swagbucks')].offers_count}">
                <span class="store-offer-footer-coupons" v-if="storeData.providers && storeData.providers[providers.indexOf('Swagbucks')].StoreOffer && storeData.providers[providers.indexOf('Swagbucks')].offers_count">
                  {{storeData.providers[providers.indexOf('Swagbucks')].offers_count}} deals
                </span>
                <router-link class="btn-main"
                             target="_blank"
                             :to="{name: 'Loader', query: {
                               url: storeData.providers[providers.indexOf('Swagbucks')].fetch_url,
                               title: 'Swagbucks',
                               type: 'cashback',
                               swagbucks_merchant_id: storeData.swagbucks_merchant_id,
                               icon: logoIsError ? imgPlaceholder() : storeData.computed_logo,
                               storeImage: storeData.providers[providers.indexOf('Swagbucks')].image || staticSwagbucksLogo,
                               lcid: $route.query.lcid
                             }}"
                              @click="getSwagbucks">
                  Get deal
                </router-link>
              </div>
            </div>
          </div>

          <div class="w-100" :class="{'order-3': swagbucksMoreThanRakuten}" v-if="providers.includes('CouponApi')">
            <div class="deals-title">
              <span>Deals</span>
              <span class="deals-title-info">{{storeData.providers[providers.indexOf('CouponApi')].offers_count}} deals</span>
            </div>
            <div class="deals-wrapper" :class="{'-show-all': showAllDeals}">
              <div class="deal-block" v-for="deal in deals" :key="deal.id">
                <div class="deal" :class="deal && deal.coupons != null ? 'discount' : 'shipping'" @click="setOpenDeal(deal)">
                  <div class="deal-title" v-if="deal && deal.cashback">{{deal.cashback}}</div>
                  <div class="deal-text" v-if="deal && deal.offer_description">{{deal.offer_description}}</div>
                  <div class="deal-date" v-if="deal && deal.start_date && deal.end_date">
                    <span v-if="deal && deal.start_date">{{deal.start_date}}</span> -
                    <span v-if="deal && deal.end_date">{{deal.end_date}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="deals-btn-block" v-if="deals && deals.length > 5 && !showAllDeals">
              <span @click="showAllDeals = true" class="btn-main -large -full relative text-center">
                See all deals
                <svg class="arrow-in-btn" width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.75847 1.35199L7.50178 0.571521C7.81651 0.241052 8.32544 0.241052 8.63682 0.571521L15.1458 7.40238C15.4605 7.73285 15.4605 8.26722 15.1458 8.59418L8.63682 15.4286C8.32209 15.759 7.81316 15.759 7.50178 15.4286L6.75847 14.6481C6.44039 14.3141 6.44709 13.7692 6.77187 13.4422L10.8065 9.40629H1.1837C0.738386 9.40629 0.380127 9.03012 0.380127 8.56254V7.43754C0.380127 6.96996 0.738386 6.59379 1.1837 6.59379H10.8065L6.77187 2.55785C6.44374 2.2309 6.43705 1.68597 6.75847 1.35199Z" fill="#DFF8F4"/>
                </svg>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SocialShare from "@/components/SocialShare";
import vClickOutside from 'click-outside-vue3'
import { reportEvent } from "@/utils";
import {performRequest} from "../api";
import {MAIN_API_URL} from "../utils";

export default {
  components: {SocialShare},
  props: ['propsStoreData', 'storeIsOpen', 'storeInExt'],
  name: 'Store',
  data: function (){
    return {
      showAllDeals: false,
      openDeal: false,
      dealIsLoading: false,
      storeData: this.propsStoreData,
      shareIsOpen: false,
      loaderStoreTitle: null,
      isFavorite: this.storeData && localStorage.getItem('saved') ? localStorage.getItem('saved').includes(this.storeData.name) : false,
      swapped: false,
      logoIsError: false,
      staticRakutenLogo: 'https://static.ebates.com/static/svg/rakuten/rakuten_nav_gradient.svg',
      staticSwagbucksLogo: 'https://assets.brandfetch.io/df3e360ecafc4ac.png'
    }
  },
  computed : {
    providers () {
      let providers = [];
      this.storeData.providers.forEach(item => {
        providers.push(item.name)
      })
      return providers
    },
    storeCoupons() {
      let storeCouponsCount = 0
      this.storeData.providers[1].StoreOffer.forEach(item => item.coupons ? storeCouponsCount++ : null)
      return storeCouponsCount
    },
    couponsApiProvider() {
      if(this.storeData && this.storeData.providers && this.providers.includes('CouponApi') &&
          this.storeData.providers[this.providers.indexOf('CouponApi')].StoreOffer.length){
          return this.storeData.providers[this.providers.indexOf('CouponApi')]
      }
      return null
    },
    deals() {
      if (this.couponsApiProvider) {
        if (this.showAllDeals){
          return this.couponsApiProvider.StoreOffer
        } else {
          return this.couponsApiProvider.StoreOffer.slice(0,6)
        }
      }
      return null
    },
    storeUrl () {
      return this.storeData.host.replace('*.', 'https://')
    },
    swagbucksMoreThanRakuten(){
      if(this.providers.includes('Rakuten') && this.providers.includes('Swagbucks')){
        return this.storeData.providers[this.providers.indexOf('Rakuten')].cashback_max <
            this.storeData.providers[this.providers.indexOf('Swagbucks')].cashback_max
      } else {
        return false
      }
    }
  },
  methods: {
    closeStore(){
      this.showAllDeals = false;
      if (this.$route.params.storeId) {
        this.$router.push('/');
      } else {
        this.$emit('closestore')
      }
    },
    hideSocialShare () {
      this.shareIsOpen = false
    },
    setOpenDeal (deal){
      let dealFull = deal
      dealFull.store_name = this.storeData.name
      dealFull.computed_logo = this.storeData.computed_logo
      dealFull.url = this.couponsApiProvider.fetch_url
      dealFull.storeImage = this.couponsApiProvider.image

      this.$emit('opendeal', dealFull)
    },
    setCloseDeal () {
      this.$emit('closedeal')
    },
    toggleSaved (){
      reportEvent('store', {
            action: 'click_favorite',
            key: this.storeData.host,
            ref: 'home'
          })
      let savedItems = JSON.parse(localStorage.getItem('saved'));
      savedItems = savedItems ? savedItems : []
      const index = savedItems ? savedItems.findIndex(item => item.name === this.storeData.name) : null
      if (index !== -1) {
        this.isFavorite = false;
        savedItems.splice(index, 1)
        reportEvent('favorite', {
          action: 'remove',
          key: this.storeData.host
        })
      } else {
        const savedStore = {
          name: this.storeData.name,
          description: this.storeData.description,
          computed_logo: this.storeData.computed_logo,
          link: this.storeData.link,
          providers: this.storeData.providers,
          host: this.storeData.host,
          offers_count: this.storeData.offers_count,
          cashback_max: this.storeData.cashback_max,
          cashback_max_currency: this.storeData.cashback_max_currency,
          cashback_max_description: this.storeData.cashback_max_description,
          website: this.storeData.website,
        }
        savedItems.push(savedStore)
        this.isFavorite = true;
        reportEvent('favorite', {
          action: 'add',
          key: this.storeData.host
        })
      }
      this.$emit('changesaved', savedItems)
    },
    shareDeals(){
      this.shareIsOpen = true
      reportEvent('store', {
        action: 'click_share',
        key: this.storeData.host,
        ref: 'home'
      })
    },
    visitStore(){
      reportEvent('store', {
        action: 'click_visit_store',
        key: this.storeData.host,
        affiliateRedirect: this.storeData.swagbucks_merchant_id ? 'yes' : 'no',
        ref: 'home'
      })
    },
    getRakuten(){
      reportEvent('store', {
        action: 'click_provider_name',
        provider: 'Rakuten',
        key: this.storeData.host,
        affiliateRedirect: this.storeData.rakuten_merchant_id ? 'yes' : 'no',
        ref: 'home'
      })
    },
    getSwagbucks(){
      reportEvent('store', {
        action: 'click_provider_name',
        provider: 'Swagbucks',
        key: this.storeData.host,
        affiliateRedirect: this.storeData.swagbucks_merchant_id ? 'yes' : 'no',
        ref: 'home'
      })
    },
    imgPlaceholder() {
      return require('../assets/img/cashback-icon.svg');
    },

    checkLogo() {
      const img = new Image();
      img.src = this.storeData.computed_logo;
      const $this = this
      img.onload = function() {
        if (this.width < 10){
          $this.logoIsError = true
        }
      }
    }
  },
  mounted () {
    if (!this.storeData) {
      performRequest(
          `${MAIN_API_URL}get_store_by_id?id=${this.$route.params.storeId}`,
          {
            method: 'POST'
          }
      ).then(res => {
        this.storeData = res.data.store;
        this.$emit('setActiveStore', res.data.store)
        this.checkLogo();
      })
    } else {
      this.checkLogo();
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  }
}
</script>

<style lang="scss">

.deals {
  &-title {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    font-size: 18px;
    font-weight: 700;
    margin: 35px 0 15px;

    &-info {
      font-weight: 400;
      font-size: 16px;
      color: #7E7B95;
    }
  }
  &-wrapper {
    background: #FFFFFF;
    box-shadow: 0px 4px 12px rgb(0 0 0 / 8%);
    border-radius: 8px 8px 0 0;

    &.-show-all {
      border-radius: 8px;
    }
  }

  &-btn-block {
    padding: 15px;
  }
}

.deal {
  padding: 15px 35px 15px 45px;
  position: relative;
  cursor: pointer;

  &:before,
  &:after {
    content: "";
    display: block;
    position: absolute;
  }

  &:before {
    left: 15px;
    top: 15px;
    width: 20px;
    height: 20px;
  }

  &.discount {
    .deal-title {
      color: #E2677D;
    }
    &:before {
      background: url("~@/assets/img/percent.svg") no-repeat center/contain;
    }
  }

  &.shipping {
    .deal-title {
      color: #4B2EFF;
    }
    &:before {
      background: url("~@/assets/img/refresh.svg") no-repeat center/contain;
    }
  }

  &:after {
    right: 15px;
    bottom: 15px;
    width: 15px;
    height: 15px;
    background: url("~@/assets/img/arrow-r.svg") no-repeat center/contain;
  }

  &-title {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 4px;
  }

  &-text {
    font-weight: 500;
    color: #7e7b95;
    font-size: 13px;
  }

  &-date {
    color: #7E7B95;
    font-size: 14px;
    font-weight: 700;
    margin-top: 4px;

    &:before {
      content: "";
      display: inline-block;
      width: 12px;
      height: 12px;
      margin-right: 5px;
      vertical-align: middle;
      background: url("~@/assets/img/calendar.svg") no-repeat center/contain;
    }
  }

  &-block {
    width: 100%;
    position: relative;
    border-bottom: 2px solid rgba(241, 239, 255, 0.5);

    &:after {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      bottom: -2px;
      display: block;
      border-bottom: 2px dotted #C4BBFA;
    }

    &:last-child:after,
    &:nth-last-child(2):after {
      border-bottom: 0;
    }
  }
}
.store {
  &-content {
    padding: 0 15px;
  }

  &-logo {
    text-align: center;

    img {
      max-height: 100px;
      min-width: 50px;
      max-width: 70%;
    }
  }

  &-text {
    font-size: 14px;
    line-height: 1.4;
    color: #514E68;
    padding: 5px 15px;
  }

  &-offer {
    background: #FFFFFF;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 15px;
    border: 1px solid #D5CFF5;

    &-header,
    &-footer {
      display: flex;
      align-items: center;
      justify-content: space-between;

      &.-end {
        justify-content: flex-end;
      }

      &-logo {
        max-height: 60px;
        border-radius: 10px;
      }

      &-coupons {
        font-size: 10px;
        font-weight: 700;
        color: #00c6a2;
      }
    }

    &-header .promocode-cashback {
      margin-left: 10px;
    }

    &-text {
      font-weight: 700;
      color: #514E68;
      font-size: 14px;
      margin: 10px 0;
    }
  }

  &-controls {
    padding: 20px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  &-control {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
    font-size: 13px;
    color: #514E68;
    cursor: pointer;
    padding: 10px;
    border-radius: 12px;
    transition: all 0.3s;
    flex: 0 0 33%;

    &:hover {
      background: #F7F7FC;
    }

    svg {
      margin-bottom: 6px;
    }
  }
}

.favorite-active {
  fill: #00c6a2;
}

.provider-list {
  display: flex;
  flex-direction: column;
}

@media all and (min-width: 500px){
  .store-controls {
    max-width: 400px;
    min-height: 114px;
    margin: 0 auto;
  }
}

@media all and (min-width: 1100px){
  .main-setting-title {
    padding: 40px;
  }

  .result,
  .saved,
  .setting {
    .back-to-result {
      right: 20px;
      top: 20px;
      left: auto;
      width: 18px;
      height: 18px;
      background-image: url('../assets/img/cross.svg');
      background-size: contain;
    }
  }

  .store-text {
    padding: 0;
  }

  .provider-list {
    padding: 40px 66px;
  }
}

.order-1 {
  order: 1;
}

.order-3 {
  order: 3;
}

</style>
